import { buildMiddleware } from 'utilities/state';

const stateKey = 'supervisor';
const storeKey = 'store:supervisor';

const serialize = (appStore, state) => {
    const config = {
        ...state[stateKey]
    };

    delete config.requestingDivisions;
    delete config.requestingDivisionData;
    
    appStore.set(storeKey, config);
};

const deserialize = (appStore, state) => state[stateKey] = appStore.get(storeKey) || {};

export default buildMiddleware(serialize, deserialize);
